import { IOption } from '@/interfaces';

import { CheckInStatus, ProfileType } from '@/features/check-in-logs/enums';
import { getCheckInStatusLabel, getProfileTypeLabel } from '@/features/check-in-logs/utils';

export const CHECK_IN_STATUS_OPTIONS: IOption[] = [
  {
    label: getCheckInStatusLabel(CheckInStatus.Success),
    value: CheckInStatus.Success.toString(),
  },
  {
    label: getCheckInStatusLabel(CheckInStatus.Failed),
    value: CheckInStatus.Failed.toString(),
  },
  {
    label: getCheckInStatusLabel(CheckInStatus.SpoofingSuspected),
    value: CheckInStatus.SpoofingSuspected.toString(),
  },
];

export const PROFILE_TYPE_OPTIONS: IOption[] = [
  {
    label: getProfileTypeLabel(ProfileType.Employee),
    value: ProfileType.Employee.toString(),
  },
  {
    label: getProfileTypeLabel(ProfileType.Guest),
    value: ProfileType.Guest.toString(),
  },
];
